<template>
	<div class="page-header">
		<div class="summary">
			<p class="typo-body-2 m-0">
				<span class="color-hypertext font-weight-bold">คัดลอกมาจาก</span>:
				<a
					class="color-hypertext"
					:href="originalPromotionUrl"
					target="_blank"
					rel="noopener"
				>{{ promotionName || defaultPromotionName }}</a>
				<span class="separated color-black-45">ID: {{ promotionId }}</span>
			</p>
			<p class="typo-body-2 m-0">
				วันที่ใช้งาน: <span class="color-black-45">ถูกล้างแล้ว กรอกใหม่ก่อนไปขั้นถัดไป</span>
			</p>
			<p v-if="isECoupon" class="typo-body-2 m-0">
				โค้ดคูปอง: <span class="color-black-45">ไม่ได้คัดลอกมา สร้างชุดใหม่ในขั้นตอน e-Coupon</span>
			</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PromotionDuplicatedNotice',

	props: {
		promotionId: {
			type: [String, Number],
			default: null,
		},
		promotionName: {
			type: String,
			default: null,
		},
		isECoupon: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		defaultPromotionName() {
			return `โปรโมชัน #${this.promotionId}`;
		},

		// ใช้ href ตรง ๆ เพื่อให้เปิดแท็บใหม่จริง ๆ โดยไม่ต้องพึ่งพฤติกรรมของ router-link
		// ฟอร์มที่กรอกค้างไว้ในแท็บเดิมจะไม่หาย
		originalPromotionUrl() {
			if (!this.promotionId) {
				return null;
			}

			return this.$router.resolve({ name: 'PromotionEdit', params: { id: this.promotionId } }).href;
		},
	},
};
</script>

<style lang="scss" scoped>
	// เข้าชุดกับ .page-header + .summary ของหน้า PromotionEdit
	// หน้า Create ต้องยกเลิกแถบเทาที่ tabs ดึงขึ้นมา 200px ด้วย ไม่งั้น header จะไปนั่งบนพื้นเทา
	// (ดู scoped style `.has-duplicated-notice` ใน PromotionCreate.vue)
	.page-header {
		margin: 0 rem(-28);
		padding: rem(4) rem(28) rem(16);

		background-color: $color-white;
	}

	.summary {
		.separated {
			&::before {
				content: "|";
				display: inline-block;

				margin-left: rem(5);
				margin-right: rem(5);
			}
		}
	}
</style>
